export const checkPermission = (menuList) => {
	for (let item of menuList) {
		if (item.children?.length > 0) {
			const result = checkPermission(item.children);
			if (result) {
				return result;
			}
		} else if (checkUrl(item) && checkPagePermission(item)) {
			return true;
		}
	}
	return false;
};

const checkUrl = (item) => {
	const currentUrl = window.location.hash.replace('#', '');
	// 不能使用 currentUrl.includes() 进行判断，因为无法排除 -admin 的情况
	return currentUrl === item.key
		|| currentUrl === item.key + '/edit'
		|| currentUrl === item.key + '/add'
		|| currentUrl === item.key + '/detail'
		|| currentUrl === item.key + '/changeName'
		|| /\/(\d+)$/.test(currentUrl.split(item.key)[1])
		|| /\/(\d+)\/edit/.test(currentUrl.split(item.key)[1]);
};

export const checkPagePermission = (item) => {
	const userRole = sessionStorage.getItem('rain');
	if (userRole?.includes('社联')) {
		return item.role ? item.role === 'admin' : item;
	} else if (userRole?.includes('社会') || userRole?.includes('社团')) {
		return item.role ? item.role === 'both' || item.role === 'group' : item;
	} else if (userRole?.includes('民非') || userRole?.includes('基金会')) {
		return item.role ? item.role === 'both' || item.role === 'science' : item;
	}
};